import React from "react";
import Label from "../label";
import MessageError from "../../message/__errors";
import "../styles.css";

// Текстовое поле. Подпись — children; placeholder по умолчанию равен подписи.
export default function InputText({ value = '', children, placeholder, errors, className = '', hasLabel = true, ...other }) {
    if (placeholder === undefined) placeholder = children;
    return <>
        {hasLabel ? <Label>{children}</Label> : null}
        <input
            {...other}
            type="text"
            value={value ? value : ''}
            className={`input ${className}`}
            placeholder={placeholder}
        />
        {errors ? <MessageError errors={errors}/> : null}
    </>;
}
